import { useState } from 'react';

export default function useToggle(initialState = false): [state: boolean, toggle: () => void] {
  const [state, setState] = useState(initialState);
  const toggle = () => setState(!state);
  return [state, toggle];
}
